import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'

const Table = ({ data, className = '' }) => {
  const headerData =
    data?.length && Array.isArray(data)
      ? Object.keys(data[0]).map((item, i) => (
          <th key={`${item}-${i}`} className="table__header-cell">
            <Paragraph weight="bold">{item}</Paragraph>
          </th>
        ))
      : ''
  const bodyData =
    data?.length && Array.isArray(data)
      ? data.map((element, i) => {
          return (
            <tr key={i} className="table__body-row">
              {Object.keys(data[0]).map((item, index) => (
                <td
                  key={`${item}-${element[item]}-${index}`}
                  className="table__body-cell"
                >
                  <Paragraph weight="book">{element[item]}</Paragraph>
                </td>
              ))}
            </tr>
          )
        })
      : ''

  return (
    <table className={`table ${className}`}>
      <thead className="table__header">
        <tr className="table__header-row">{headerData}</tr>
      </thead>
      <tbody className="table__body">{bodyData}</tbody>
    </table>
  )
}

export default Table
